module.exports = __webpack_public_path__ + "img/butter-y.0ffea21a.png";